<template>
    <div id="feedback">
        <a-card title="用户反馈列表">
             <a-tabs default-active-key="1" @change="callback">
                <a-tab-pane key="1" tab="抄表">
                    
                </a-tab-pane>
                <a-tab-pane key="2" tab="巡检">
                    
                </a-tab-pane>
             </a-tabs>

             <a-list 
                :data-source="list" 
                :pagination='pagination' 
             >
                <a-list-item slot="renderItem" slot-scope="item" @click='del(item.id)'>
                    <a-list-item-meta :description="item.content">
                    <span slot="title">{{ item.userName }}</span>
                    <a-avatar
                        slot="avatar"
                        :src="item.url"
                    />
                    </a-list-item-meta>
                    <div>
                        {{item.createTime}}
                    </div>
                </a-list-item>
                <!-- <div v-if="loading && !busy" class="demo-loading-container">
                    <a-spin />
                </div> -->
            </a-list>
        </a-card>
    </div>
</template>

<script>
import mixinViewModule from '@/mixin/commonModel'
export default {
    mixins: [mixinViewModule],
    data(){
        return{
            queryUrl: '/pipe-network/meter_reading_opinions/page',
            deleteUrl: '/pipe-network/meter_reading_opinions/',
            query:{
                sysType:'抄表'
            },
            // selectrows: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showTotal: total => `共 ${total} 条记录`,
                // showSizeChanger: true,
                // showQuickJumper: true,
                // pageSizeOptions: ['10', '20', '50', '100'],
                onChange: page => {
                    this.pagination.current = page;
                    this.pageQueryList();
                },
            },
        }
    },
    created(){
        
    },
    methods:{
       callback(key){
           if(key == 1){
               this.query.sysType = '抄表';
           }else{
               this.query.sysType = '巡检';
           }
           this.queryList();
       },
       del(id){
           this.selectedRows.push(id);
           this.deleteSelectRow();
       }
    }
}
</script>

<style scoped>

</style>